import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import { QR_POPUP } from 'constants/ComponentNames';

import { getLangCountryPrefix } from 'helpers/utils';

import { useMatchMedia } from 'hooks/useMatchMedia';
import promoBreakpoints from 'theme/promoBreakpoints';

import { PromoButton } from './PromoButton';
import PromoPopup from '../../popup/PromoPopup';
import QRPopup from '../Popups/QRPopup';
import RequestFormPopup from '../Popups/RequestFormPopup/RequestFormPopup';

const PromoButtonExtended = (props) => {
    const isTablet = useMatchMedia(promoBreakpoints.tablet744);
    const btn = !isTablet && props.isMobileBtn ? props.btnMobile : props.btn;
    const popupRef = useRef(null);

    const selectPopupSnippet = (popupName) => {
        if (popupName === QR_POPUP) {
            popupRef.current?.open(<QRPopup hasAppsBtns={true} popupRef={popupRef} />);
        } else {
            popupRef.current?.open(<RequestFormPopup sendFrom={props.sendFrom} popupRef={popupRef} />);
        }
    };
    const clickHandler = () => {
        if (btn && btn.btn_modal && btn.isModal) {
            selectPopupSnippet(btn.btn_modal);
        }
        if (btn.analyticsHandler) {
            btn.analyticsHandler();
        }
    };

    return (
        <>
            {btn && btn.title && btn.btn_modal && btn.isModal && (
                <PromoButton
                    onClick={clickHandler}
                    onKeyPress={clickHandler}
                    caption={btn.title}
                    variant={props.variant}
                    iconName={props.iconName}
                    isInverted={props.isInverted}
                    tabIndex={'0'}
                />
            )}
            {btn && btn.title && !btn.isModal && (
                <PromoButton
                    type={'link'}
                    href={props.hasLangCountry ? `${getLangCountryPrefix(props.lang, props.country)}${btn.url}` : btn.url}
                    target={btn.isBlank ? '_blank' : null}
                    caption={btn.title}
                    variant={props.variant}
                    iconName={props.iconName}
                    isInverted={props.isInverted}
                    tabIndex={'0'}
                    onClick={clickHandler}
                />
            )}
            <PromoPopup ref={popupRef} />
        </>
    );
};
PromoButtonExtended.propTypes = {
    btn: PropTypes.object,
    btnMobile: PropTypes.object,
    isMobileBtn: PropTypes.bool,
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    iconName: PropTypes.string,
    isInverted: PropTypes.bool,
    hasLangCountry: PropTypes.bool,
    lang: PropTypes.string,
    country: PropTypes.string,
};

export default PromoButtonExtended;
